import {
  Companion_instancecsbm5ewxyfnq as Companion_instance,
  AlwaysSharedCopyTracker_getInstance1rs3z6uqvhgfu as AlwaysSharedCopyTracker_getInstance,
} from './Segment.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SegmentPoolClass;
function SegmentPool() {
  if (SegmentPoolClass === VOID) {
    class $ {
      constructor() {
        this.k4k_1 = 0;
        this.l4k_1 = 0;
      }
      o3x() {
        return Companion_instance.n4l();
      }
      a4l(segment) {
      }
      r4l() {
        return AlwaysSharedCopyTracker_getInstance();
      }
    }
    initMetadataForObject($, 'SegmentPool');
    SegmentPoolClass = $;
  }
  return SegmentPoolClass;
}
var SegmentPool_instance;
function SegmentPool_getInstance() {
  return SegmentPool_instance;
}
//region block: init
SegmentPool_instance = new (SegmentPool())();
//endregion
//region block: exports
export {
  SegmentPool_instance as SegmentPool_instanceps1mclk6cv3l,
};
//endregion

//# sourceMappingURL=SegmentPool.mjs.map
